import { Mapping } from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import { Eleve } from '@teetsh/app/src/types/eleves';
import { matchEleve } from './matchEleve';
import { getBirthday } from '../getElevesFromCsv';
import { getMappingItem, getCustomFields } from '../../utils/getMappingItem';
import { getFieldFromRow } from '../../utils/getFieldFromRow';
import { Gender } from '@teetsh/app/src/types/gender';

export interface EleveMapping {
  givenName: string;
  familyName: string;
  birthday?: Date;
  gender?: Gender;
  ine?: string;
  existingEleve?: Eleve;
  customFields?: { [key: string]: string };
}

export function getElevesMapping(
  rows: object[],
  mappings: Mapping[] | null,
  eleves: Eleve[],
): EleveMapping[] {
  const ineMapping = getMappingItem(mappings, 'ine');
  const givenNameMapping = getMappingItem(mappings, 'givenName');
  const genderMapping = getMappingItem(mappings, 'gender');
  const birthdayMapping = getMappingItem(mappings, 'birthday');
  const familyNameMapping = getMappingItem(mappings, 'familyName');
  const customFieldsMapping = getCustomFields(mappings);

  return (rows || []).map(row => {
    const rowFamilyName = getFieldFromRow(row, familyNameMapping);
    const rowGivenName = getFieldFromRow(row, givenNameMapping);
    const rowGender = getFieldFromRow(row, genderMapping);
    const rowBirthday = getFieldFromRow(row, birthdayMapping);
    const rowINE = getFieldFromRow(row, ineMapping);

    const matchingEleves = matchEleve(rowGivenName, rowFamilyName, eleves);
    const result = {
      givenName: rowGivenName,
      familyName: rowFamilyName,
      birthday: getBirthday(rowBirthday),
      gender: rowGender,
      ine: rowINE,
      existingEleve: matchingEleves,
    };
    const customFields = customFieldsMapping.reduce((acc, mapping) => {
      const fieldValue = getFieldFromRow(row, mapping);
      if (!fieldValue) {
        return acc;
      }

      return {
        ...acc,
        [mapping.mapping]: getFieldFromRow(row, mapping),
      };
    }, {});

    if (Object.keys(customFields).length > 0) {
      return {
        ...result,
        customFields,
      };
    }
    return result;
  });
}
